import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import LibraryPage from "../Library/LibraryPage";
import { Typography, Button, Row, Tooltip } from "antd";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";

const { Title } = Typography;

const DistrictQuestionbanksItemDetail = (props) => {
  console.log("DistrictQuestionbanksItemDetail props", props)
  const { questionbank } = props;
  const history = useHistory();
  const mrIntl = useTranslate();

  const handleBack = () => {
    history.push("/u/library");
  };

  return (
    <React.Fragment>
      <Row>
        <Tooltip title="Back">
          <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => handleBack()} className="m-r-10" />
        </Tooltip>
        <Title level={4} className="align-items-center-with-flex m-b-0">{questionbank?.title || mrIntl("DistrictQuestionbanksItemDetail.question_bank")}</Title>
      </Row>
      <LibraryPage {...props} />
    </React.Fragment>
  );
}

export default DistrictQuestionbanksItemDetail;